import { RESET_STATE } from 'store/global/actions';

import { CUSTOM_FIELDS_ACTION_TYPE } from '../actions';

const initialState = {};

const customFieldsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CUSTOM_FIELDS_ACTION_TYPE.GET_CUSTOM_FIELDS:
      return payload ?? initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default customFieldsReducer;
